/* ============================================================
   InverTerra — Interacciones de la landing page
   ============================================================ */ // Endpoint del formulario de lista de espera: Pages Function servida por
// Cloudflare Pages (functions/api/waitlist.js) que persiste los datos en D1.
// En local se accede vía `yarn dev:pages` (puerto 8788). Si queda vacío,
// los envíos del wizard se simulan en el cliente con fines de demostración.
const FORM_ENDPOINT = '/api/waitlist';
document.addEventListener('DOMContentLoaded', ()=>{
    'use strict';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* ---------- Navbar: estado al hacer scroll ---------- */ const navbar = document.getElementById('navbar');
    const onScroll = ()=>{
        navbar.classList.toggle('nav-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    /* ---------- Menú móvil ---------- */ const menuBtn = document.getElementById('menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    const iconMenu = document.getElementById('icon-menu');
    const iconClose = document.getElementById('icon-close');
    const setMenu = (open)=>{
        mobileMenu.classList.toggle('hidden', !open);
        iconMenu.classList.toggle('hidden', open);
        iconClose.classList.toggle('hidden', !open);
        menuBtn.setAttribute('aria-expanded', String(open));
        menuBtn.setAttribute('aria-label', open ? "Cerrar men\xfa" : "Abrir men\xfa");
    };
    menuBtn.addEventListener('click', ()=>{
        setMenu(mobileMenu.classList.contains('hidden'));
    });
    mobileMenu.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', ()=>setMenu(false));
    });
    /* ---------- Aparición de elementos al hacer scroll ---------- */ const revealEls = document.querySelectorAll('.reveal');
    if (prefersReduced || !('IntersectionObserver' in window)) revealEls.forEach((el)=>el.classList.add('is-visible'));
    else {
        const revealObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                const el = entry.target;
                el.style.transitionDelay = `${el.dataset.delay || 0}ms`;
                el.classList.add('is-visible');
                revealObserver.unobserve(el);
            });
        }, {
            threshold: 0.15,
            rootMargin: '0px 0px -48px 0px'
        });
        revealEls.forEach((el)=>revealObserver.observe(el));
    }
    /* ---------- Contadores animados (rendimiento) ---------- */ const counters = document.querySelectorAll('[data-count]');
    const setFinalValue = (el)=>{
        el.textContent = el.dataset.count;
    };
    const animateCounter = (el)=>{
        const target = Number(el.dataset.count);
        const duration = 1400;
        const start = performance.now();
        const tick = (now)=>{
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = String(Math.round(target * eased));
            if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    if (prefersReduced || !('IntersectionObserver' in window)) counters.forEach(setFinalValue);
    else {
        const counterObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                animateCounter(entry.target);
                counterObserver.unobserve(entry.target);
            });
        }, {
            threshold: 0.6
        });
        counters.forEach((el)=>counterObserver.observe(el));
    }
    /* ---------- Formulario progresivo (wizard) de lista de espera ---------- */ const form = document.getElementById('waitlist-form');
    if (form) {
        const successBox = document.getElementById('form-success');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        const steps = [
            ...form.querySelectorAll('.form-step')
        ];
        const progressSteps = [
            ...form.querySelectorAll('.progress-step')
        ];
        let currentStep = 1;
        const step1NextBtn = document.getElementById('step-1-next');
        const step2NextBtn = document.getElementById('step-2-next');
        const step2SkipBtn = document.getElementById('step-2-skip');
        const step3SkipBtn = document.getElementById('step-3-skip');
        /* ----- Utilidades ----- */ const setError = (field, message)=>{
            const errorEl = document.getElementById(`err-${field}`);
            if (!errorEl) return;
            errorEl.textContent = message || '';
            errorEl.classList.toggle('hidden', !message);
        };
        const clearErrors = ()=>{
            [
                'nombre',
                'email',
                'consent',
                'form'
            ].forEach((field)=>setError(field, ''));
        };
        const updateProgress = (step)=>{
            progressSteps.forEach((item)=>{
                const n = Number(item.dataset.step);
                item.classList.toggle('is-done', n < step);
                item.classList.toggle('is-active', n === step);
                if (n === step) item.setAttribute('aria-current', 'step');
                else item.removeAttribute('aria-current');
            });
        };
        const goToStep = (step)=>{
            currentStep = step;
            steps.forEach((s)=>s.classList.toggle('hidden', Number(s.dataset.step) !== step));
            updateProgress(step);
            const active = steps.find((s)=>Number(s.dataset.step) === step);
            const firstField = active.querySelector('input, textarea');
            if (firstField) firstField.focus({
                preventScroll: true
            });
        };
        // Envío de datos al backend. Sin FORM_ENDPOINT configurado se simula (demo).
        const sendPayload = async (payload)=>{
            if (!FORM_ENDPOINT) {
                await new Promise((resolve)=>setTimeout(resolve, 700));
                return;
            }
            const response = await fetch(FORM_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
        };
        const collectBase = ()=>({
                nombre: form.nombre.value.trim(),
                email: form.email.value.trim(),
                telefono: form.telefono.value.trim()
            });
        const validateStep1 = ()=>{
            clearErrors();
            const base = collectBase();
            let isValid = true;
            if (base.nombre.length < 2) {
                setError('nombre', "Ingres\xe1 tu nombre completo.");
                isValid = false;
            }
            if (!emailPattern.test(base.email)) {
                setError('email', "Ingres\xe1 un email v\xe1lido.");
                isValid = false;
            }
            if (!form.consent.checked) {
                setError('consent', 'Necesitamos tu consentimiento para contactarte.');
                isValid = false;
            }
            return isValid;
        };
        const showSuccess = ()=>{
            form.classList.add('hidden');
            successBox.classList.remove('hidden');
            successBox.setAttribute('tabindex', '-1');
            successBox.focus();
        };
        /* ----- Paso 1 → registra el contacto y avanza ----- */ step1NextBtn.addEventListener('click', async ()=>{
            if (!validateStep1()) return;
            step1NextBtn.disabled = true;
            step1NextBtn.textContent = "Enviando\u2026";
            try {
                await sendPayload({
                    ...collectBase(),
                    consentimiento: true,
                    etapa: 'registro'
                });
                goToStep(2);
            } catch (error) {
                setError('form', "No pudimos enviar tus datos. Intent\xe1 nuevamente en unos minutos.");
            } finally{
                step1NextBtn.disabled = false;
                step1NextBtn.textContent = 'Continuar';
            }
        });
        /* ----- Paso 2 → actualización opcional del perfil (no bloqueante) ----- */ step2NextBtn.addEventListener('click', ()=>{
            const update = {
                email: form.email.value.trim(),
                monto: form.querySelector('input[name="monto"]:checked')?.value || '',
                objetivos: [
                    ...form.querySelectorAll('input[name="objetivo"]:checked')
                ].map((input)=>input.value),
                etapa: 'perfil'
            };
            sendPayload(update).catch((err)=>console.warn('InverTerra: no se pudo enviar el perfil.', err));
            goToStep(3);
        });
        step2SkipBtn.addEventListener('click', ()=>goToStep(3));
        /* ----- Botones "Volver" ----- */ form.querySelectorAll('[data-goto]').forEach((btn)=>{
            btn.addEventListener('click', ()=>goToStep(Number(btn.dataset.goto)));
        });
        /* ----- Paso 3 → cierre del registro ----- */ form.addEventListener('submit', (event)=>{
            event.preventDefault();
            // Enter dentro de un paso previo actúa como "Continuar".
            if (currentStep === 1) {
                step1NextBtn.click();
                return;
            }
            if (currentStep === 2) {
                step2NextBtn.click();
                return;
            }
            // Por si se volvió al paso 1 y se modificó algún dato esencial.
            if (!validateStep1()) {
                goToStep(1);
                return;
            }
            const finalUpdate = {
                email: form.email.value.trim(),
                experiencia_agro: form.querySelector('input[name="experiencia"]:checked')?.value || '',
                comentario: form.comentario.value.trim(),
                etapa: 'completo'
            };
            sendPayload(finalUpdate).catch((err)=>console.warn('InverTerra: no se pudo enviar el cierre.', err));
            showSuccess();
        });
        // "Omitir y finalizar" en el paso 3.
        step3SkipBtn.addEventListener('click', showSuccess);
    }
    /* ---------- Año dinámico en el footer ---------- */ const yearEl = document.getElementById('year');
    if (yearEl) yearEl.textContent = String(new Date().getFullYear());
});

//# sourceMappingURL=inverterra.eab529de.js.map
